var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    fill: "none",
    height: "100%",
    viewBox: "0 0 110 102",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "metamask"
  }, "MetaMask Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "metamask"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.496 1L61.4061 32.2606L69.1895 13.8173L103.496 1Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32995 1L48.0812 32.5567L40.6785 13.8173L6.32995 1Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3519 73.4619L77.1421 90.6362L101.127 97.2352L108.022 73.8426L88.3519 73.4619Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88832 73.8426L8.74111 97.2352L32.7259 90.6362L21.5161 73.4619L1.88832 73.8426Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3722 44.4433L24.6887 54.5533L48.5042 55.6108L47.6582 30.0186L31.3722 44.4433Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4535 44.4433L61.956 29.7225L61.4061 55.6109L85.1793 54.5533L78.4535 44.4433Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7259 90.6362L47.0237 83.6565L34.6717 74.0118L32.7259 90.6362Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.802 83.6565L77.1421 90.6362L75.154 74.0118L62.802 83.6565Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1421 90.6362L62.802 83.6565L63.9441 93.0051L63.8172 96.9391L77.1421 90.6362Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7259 90.6362L46.0508 96.9391L45.9662 93.0051L47.0237 83.6565L32.7259 90.6362Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2623 67.8359L34.3333 64.3249L42.7513 60.4755L46.2623 67.8359Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5635 67.8359L67.0745 60.4755L75.5347 64.3249L63.5635 67.8359Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7259 90.6362L34.7563 73.4619L21.5161 73.8426L32.7259 90.6362Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1117 73.4619L77.1421 90.6362L88.3519 73.8426L75.1117 73.4619Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1793 54.5533L61.4061 55.6108L63.6057 67.8359L67.1167 60.4754L75.577 64.3249L85.1793 54.5533Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 64.3249L42.7936 60.4754L46.2623 67.8359L48.5042 55.6108L24.6887 54.5533L34.3333 64.3249Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6887 54.5533L34.6717 74.0118L34.3333 64.3249L24.6887 54.5533Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.577 64.3249L75.154 74.0118L85.1793 54.5533L75.577 64.3249Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5042 55.6108L46.2623 67.8359L49.0541 82.2606L49.6887 63.2673L48.5042 55.6108Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4061 55.6108L60.2639 63.2251L60.7716 82.2606L63.6057 67.8359L61.4061 55.6108Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6057 67.8359L60.7716 82.2606L62.802 83.6565L75.154 74.0119L75.577 64.3249L63.6057 67.8359Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3333 64.3249L34.6717 74.0119L47.0237 83.6565L49.0541 82.2606L46.2623 67.8359L34.3333 64.3249Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8173 96.9391L63.9442 93.0051L62.8866 92.0745H46.9391L45.9662 93.0051L46.0508 96.9391L32.7259 90.6362L37.379 94.4433L46.8122 101H63.0135L72.489 94.4433L77.1421 90.6362L63.8173 96.9391Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.802 83.6565L60.7716 82.2606H49.0541L47.0237 83.6565L45.9662 93.0051L46.9391 92.0744H62.8866L63.9442 93.0051L62.802 83.6565Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.272 34.291L108.868 17.0321L103.496 1L62.802 31.203L78.4535 44.4433L100.577 50.9154L105.484 45.2047L103.369 43.6819L106.753 40.5939L104.13 38.5634L107.514 35.9831L105.272 34.291Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.0321L4.5956 34.291L2.31134 35.9831L5.69543 38.5634L3.11506 40.5939L6.49915 43.6819L4.38409 45.2047L9.24873 50.9154L31.3722 44.4433L47.0237 31.203L6.32995 1L1 17.0321Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.577 50.9154L78.4534 44.4433L85.1793 54.5533L75.154 74.0118L88.3519 73.8426H108.022L100.577 50.9154Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3722 44.4433L9.24872 50.9154L1.88831 73.8426H21.5161L34.6717 74.0118L24.6886 54.5533L31.3722 44.4433Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4061 55.6108L62.802 31.203L69.2318 13.8173H40.6785L47.0237 31.203L48.5042 55.6108L49.0118 63.3096L49.0541 82.2606H60.7716L60.8562 63.3096L61.4061 55.6108Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.968cb5bd26336adf461aa7f31af616ff.svg";
export { ForwardRef as ReactComponent };